import { appBannerMapping } from '../../../components/AppBanner/app-banner';
import hero from './mapping/hero';
import { secondaryBannerMapping } from '../../../components/SecondaryBanner';
import stepProvider from './mapping/step';
import diagonalBackground from './mapping/diagonalBackground';
import card from './mapping/card';
import titleDescription from './mapping/titleDescription';
import promotionProvider from './mapping/promotion';
import rawHtml from './mapping/rawhtml';
import { requiredDocumentationMapping } from '../../../components/RequiredDocumentation';
import { contentCard } from './mapping/contentCard';
import faq from './mapping/faq';
import imageOpening from './mapping/imageOpening';
import jobsContactForm from './mapping/jobsContactForm';
import commentsForm from './mapping/commentsForm';
import chart from './mapping/chart';
import experience from './mapping/experience';
import experienceArticle from './mapping/experienceArticle';
import parking from './mapping/parking';
import featuredBlogs from './mapping/featuredblog';
import { parkingPriceMapping } from '../../../components/ParkingPrice';
import { shuttlePriceMapping } from '../../../components/ShuttlePrice';
import { wheelsPriceMapping } from '../../../components/WheelsPrice';
import { ticketCardPropsMapping } from '../../../features/Tickets/components/ticket-card';
import { travelClubPriceMapping } from '../../../features/travel-club';

/**
 * Map components props
 * @param {string} widget - widget type
 * @param {Object} props - widget props
 * @param {string} locale - page language
 * @param {string} pageUri - page uri
 * @returns {Object}
 */
export default function mapWidgetProps(widget, props, locale, pageUri) {
  switch (widget) {
    case 'appBanner':
      return appBannerMapping(props, locale);

    case 'hero':
      return hero(props, locale);

    case 'secondaryBanner':
      return secondaryBannerMapping(props, locale);

    case 'step':
      return stepProvider(props, locale);

    case 'diagonalbackground':
      return diagonalBackground(props);

    case 'card':
      return card(props, locale);

    case 'ticketcard':
      return ticketCardPropsMapping(props, locale);

    case 'titledescription':
      return titleDescription(props, locale);

    case 'promotion':
      return promotionProvider(props, locale);

    case 'rawhtml':
      return rawHtml(props, locale, pageUri);

    case 'requiredDocumentation':
      return requiredDocumentationMapping(props, locale);

    case 'contentcard':
      return contentCard(props, locale);

    case 'faq':
      return faq(props, locale);

    case 'imageopening':
      return imageOpening(props, locale);

    case 'jobscontactform':
      return jobsContactForm(props, locale);

    case 'chart':
      return chart(props, locale);

    case 'commentsform':
      return commentsForm(props, locale);

    case 'experience':
      return experience(props, locale, pageUri);
    case 'experiencearticle':
      return experienceArticle(props, locale);

    case 'parking':
      return parking(props, locale);

    case 'parkingPrice':
      return parkingPriceMapping(props, locale);

    case 'featuredblog':
      return featuredBlogs(props, locale);

    case 'shuttlePrice':
      return shuttlePriceMapping(props, locale);

    case 'travelclubPrice':
      return travelClubPriceMapping(props, locale);

    case 'wheelsPrice':
      return wheelsPriceMapping(props, locale);
    default:
      return null;
  }
}
